import { useState, useEffect } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import _ from 'lodash'
import { formatMultipleSelectArray, standardizeOptions } from '../../../../helper/util'
import { constants } from '../../../../Constants/constants'
import { appVersionListFilters } from '../../constants'
import { newGetList, newPost, newPut, newDelete } from '../../../../helper/baseFetch_v2'

const DEFAULT_TEMPLATE = {
  code: '',
  versionConfigList: [],
}

const DEVICE_TYPES = ['PR', 'KIOSK', 'TV']
const BUILD_TARGETS = ['ANDROID_MODERN', 'ANDROID_LEGACY', 'ANDROID_MPOS', 'IOS']

export function useAppVersionTemplate() {
  const store = useStore()
  const history = useHistory()
  const { id } = useParams()
  const lang = useSelector((state) => state.lang.ui.lang)
  const theme = useSelector((state) => state.theme.ui.theme)

  const [template, setTemplate] = useState(DEFAULT_TEMPLATE)
  const [inputError, setInputError] = useState({})
  const [loading, setLoading] = useState(false)
  const [drawerAppVersionOpen, setDrawerAppVersionOpen] = useState(false)
  const [drawerType, setDrawerType] = useState(null)
  const [customFilter, setCustomFilter] = useState([])
  const [showDialog, setShowDialog] = useState(false)
  const [dialog, setDialog] = useState({ open: false, dialogActions: [] })
  const [releaseDialog, setReleaseDialog] = useState({ open: false, versionGroup: null })

  const isEdit = !!id
  const versionConfigList = template.versionConfigList ?? []

  useEffect(() => {
    if (isEdit) fetchTemplate()
  }, [id])

  async function fetchTemplate() {
    setLoading(true)
    newGetList({
      path: `gulu-console/merchant/shop-app-version-control/template/${id}`,
      successCallback: (payload) => {
        const buildTargetList = ['ANDROID_MODERN', 'ANDROID_LEGACY', 'ANDROID_MPOS', 'IOS']
        const temp = _.cloneDeep(payload)
        const deviceTypes = [...new Set(temp.versionConfigList.map((item) => item.deviceType))]
        temp.versionConfigList = deviceTypes.flatMap((deviceType) =>
            buildTargetList.map((buildTarget) => {
                const existing = temp.versionConfigList.find(
                    (item) => item.deviceType === deviceType && item.buildTarget === buildTarget
                )
                return existing ? { ...existing, forceUpdate: existing.forceUpdate ?? false } : { deviceType, buildTarget, shopAppReleaseId: null, forceUpdate: false }
            })
        )
        setTemplate(temp)
        setLoading(false)
      },
      store,
    })
  }

  function onChangeInput(name, value) {
    setTemplate((prev) => ({ ...prev, [name]: value }))
  }

  function onChangeVersionConfigList(name, value, target) {
    setTemplate((prev) => {
      const list = _.cloneDeep(prev.versionConfigList)
      const index = list.findIndex(
        (item) => item.deviceType === target.deviceType && item.buildTarget === target.buildTarget
      )
      if (index !== -1) list[index][name] = value ?? null
      return { ...prev, versionConfigList: list }
    })
  }

  function handleFolderMap(deviceType, create = true) {
    setTemplate((prev) => {
      const list = _.cloneDeep(prev.versionConfigList)
      if (create) {
        return {
          ...prev,
          versionConfigList: [
            ...list,
            ...BUILD_TARGETS.map((bt) => ({
              deviceType,
              buildTarget: bt,
              shopAppReleaseId: null,
              forceUpdate: false,
            })),
          ],
        }
      }
      return { ...prev, versionConfigList: list.filter((i) => i.deviceType !== deviceType) }
    })
  }

  function handleOnClickDrawer(event, page, buildTarget = null) {
    if (event) {
      const isMuiIcon =
        event.target.closest('.MuiAutocomplete-clearIndicator') ||
        event.target.closest('.MuiAutocomplete-popupIndicator')
      if (isMuiIcon) return
    }
    if (page === 'appVersion') {
      setDrawerType(buildTarget)
      setCustomFilter([
        ...appVersionListFilters,
        {
            className: 'filter-input',
            label: { resource: 'appVersionRestaurantPage', key: 'status' },
            value: formatMultipleSelectArray(['PILOT', 'STABLE'], constants.CHOICES.APP_VERSION.STATUS),
            type: constants.TYPE.SELECT,
            selectValue: constants.CHOICES.APP_VERSION.STATUS.filter((item) => ['PILOT', 'STABLE'].includes(item.value)),
            name: 'statusList',
            size: constants.SIZE.SMALL,
            multiple: true,
            minSelect: 1,
            disableClearable: true,
        },
        {
            className: 'filter-input',
            label: { resource: 'appVersionRestaurantPage', key: 'buildTarget' },
            value: buildTarget?.buildTarget,
            type: constants.TYPE.SELECT,
            selectValue: standardizeOptions(constants.CHOICES.APP_VERSION.BUILD_TARGET, 'value', 'name'),
            name: 'buildTarget',
            size: constants.SIZE.SMALL,
            disabled: true,
        },
        // {
        //   className: 'filter-input',
        //   label: { resource: 'appVersionRestaurantPage', key: 'status' },
        //   value: ['PILOT', 'STABLE'],
        //   type: constants.TYPE.SELECT,
        //   selectValue: constants.CHOICES.APP_VERSION.STATUS.filter((i) => ['PILOT', 'STABLE'].includes(i.value)),
        //   name: 'statusList',
        //   size: constants.SIZE.SMALL,
        //   multiple: true,
        //   minSelect: 1,
        //   disableClearable: true,
        // },
        // {
        //   className: 'filter-input',
        //   label: { resource: 'appVersionRestaurantPage', key: 'buildTarget' },
        //   value: buildTarget?.buildTarget,
        //   type: constants.TYPE.SELECT,
        //   selectValue: constants.CHOICES.APP_VERSION.BUILD_TARGET,
        //   name: 'buildTarget',
        //   size: constants.SIZE.SMALL,
        //   disabled: true,
        // },
      ])
      setDrawerAppVersionOpen(true)
    }
  }

  function onClickListRow(data, page) {
    if (page === 'appVersion') {
      setTemplate((prev) => {
        const list = _.cloneDeep(prev.versionConfigList)
        const index = list.findIndex(
          (i) => i.deviceType === drawerType?.deviceType && i.buildTarget === drawerType?.buildTarget
        )
        if (index !== -1) list[index].shopAppReleaseId = data ?? null
        return { ...prev, versionConfigList: list }
      })
      setDrawerAppVersionOpen(false)
    }
  }

  function onClickVersionRow(versionGroup) {
    setReleaseDialog({ open: true, versionGroup })
  }

  function onSelectRelease(release) {
    setReleaseDialog({ open: false, versionGroup: null })
    onClickListRow(release, 'appVersion')
  }

  function validate() {
    const errors = {}
    if (!template.code?.trim()) errors.code = 'Code is required'
    if (versionConfigList.length === 0) errors.versionConfigList = 'At least one device type is required'
    setInputError(errors)
    console.log('validation errors', errors)
    return Object.keys(errors).length === 0
  }

  async function onClickSave() {
    if (!validate()) return
    console.log('validated, ready to save', template)
    setShowDialog(true)
  }

  async function onClickConfirmSave() {
    const filterVersionConfigList = template.versionConfigList.filter((item) => item.shopAppRelease?.id != null || item.shopAppReleaseId != null)
    const formatVersionConfig = filterVersionConfigList.map((item) => ({ ...item, shopAppReleaseId: item.shopAppReleaseId?.id ?? null }))
    setShowDialog(false)
    const method = isEdit ? newPut : newPost
    const path = isEdit
      ? `gulu-console/merchant/shop-app-version-control/template/${id}`
      : 'gulu-console/merchant/shop-app-version-control/template'

    method({
      path,
      body: { code: template.code,  versionConfigList: formatVersionConfig },
      successCallback: () => {
        setDialog({
          open: true,
          dialogContentText: { key: isEdit ? 'editSuccess' : 'createSuccess' },
          dialogActions: [
            { label: { key: isEdit ? 'backEdit' : 'backCreate' }, onClick: () => setDialog({ open: false, dialogActions: [] }) },
            { label: { key: 'backList' }, onClick: onClickBackToList },
          ],
        })
      },
      store,
    })
  }

  function onClickBackToList() {
    setDialog({ open: false, dialogActions: [] })
    history.push('/' + constants.PATH.APPVERSION_TEMPLATE.APPVERSION_TEMPLATE)
  }

  // called from AppVersionRestaurantCreate "save as template"
  async function saveAsTemplate(versionConfigList, name = '') {
    return new Promise((resolve, reject) => {
      newPost({
        path: 'gulu-console/merchant/shop-app-version-template',
        body: { name, versionConfigList },
        successCallback: resolve,
        failCallback: reject,
        store,
      })
    })
  }

  return {
    template, lang, theme, loading, isEdit,
    versionConfigList,
    inputError,
    drawerAppVersionOpen, setDrawerAppVersionOpen,
    customFilter,
    showDialog, setShowDialog,
    dialog, setDialog,
    drawerType,
    onChangeInput,
    onChangeVersionConfigList,
    handleFolderMap,
    handleOnClickDrawer,
    onClickListRow,
    onClickVersionRow,
    onSelectRelease,
    releaseDialog, setReleaseDialog,
    onClickSave,
    onClickConfirmSave,
    onClickBackToList,
    saveAsTemplate,
  }
}